module.exports = __webpack_public_path__ + "static/image/company/pc/image_people.jpg?7029731b";